import React from 'react';
import { AdfBlockCard } from './AdfBlockCard';
import { AdfBlockquote } from './AdfBlockquote';
import { AdfBulletList } from './AdfBulletList';
import { AdfCodeBlock } from './AdfCodeBlock';
import { AdfDate } from './AdfDate';
import { AdfEmbedCard } from './AdfEmbedCard';
import { AdfEmoji } from './AdfEmoji';
import { AdfExpand } from './AdfExpand';
import { AdfHardBreak } from './AdfHardBreak';
import { AdfHeading } from './AdfHeading';
import { AdfInlineCard } from './AdfInlineCard';
import { AdfListItem } from './AdfListItem';
import { AdfMedia } from './AdfMedia';
import { AdfMediaSingle } from './AdfMediaSingle';
import { AdfMention } from './AdfMention';
import { AdfNodeProps } from './AdfModelTypes';
import { AdfOrderedList } from './AdfOrderedList';
import { AdfPanel } from './AdfPanel';
import { AdfParagraph } from './AdfParagraph';
import { AdfRule } from './AdfRule';
import { AdfText } from './AdfText';

export const AdfNode = React.memo(({ node }: AdfNodeProps) => {
    if (node.type === 'bulletList') return <AdfBulletList node={node} />;
    if (node.type === 'orderedList') return <AdfOrderedList node={node} />;
    if (node.type === 'listItem') return <AdfListItem node={node} />;
    if (node.type === 'paragraph') return <AdfParagraph node={node} />;
    if (node.type === 'text') return <AdfText node={node} />;
    if (node.type === 'mention') return <AdfMention node={node} />;
    if (node.type === 'blockCard') return <AdfBlockCard node={node} />;
    if (node.type === 'blockquote') return <AdfBlockquote node={node} />;
    if (node.type === 'panel') return <AdfPanel node={node} />;
    if (node.type === 'rule') return <AdfRule node={node} />;
    if (node.type === 'media') return <AdfMedia node={node} />;
    if (node.type === 'mediaSingle') return <AdfMediaSingle node={node} />;
    if (node.type === 'codeBlock') return <AdfCodeBlock node={node} />;
    if (node.type === 'date') return <AdfDate node={node} />;
    if (node.type === 'emoji') return <AdfEmoji node={node} />;
    if (node.type === 'expand') return <AdfExpand node={node} />;
    if (node.type === 'hardBreak') return <AdfHardBreak node={node} />;
    if (node.type === 'heading') return <AdfHeading node={node} />;
    if (node.type === 'inlineCard') return <AdfInlineCard node={node} />;
    if (node.type === 'embedCard') return <AdfEmbedCard node={node} />;
    return <div>{node.type}</div>;
});
